/* MOLLO — interactions légères */
document.addEventListener('DOMContentLoaded', function () {
  // Menu mobile
  var burger = document.querySelector('.burger');
  var menu = document.querySelector('.mobile-menu');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      menu.classList.toggle('open');
      burger.setAttribute('aria-expanded', menu.classList.contains('open'));
    });
  }
  // Galerie produit
  document.querySelectorAll('.galerie-thumbs button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.querySelector('.galerie-main img');
      if (main && btn.dataset.src) {
        main.src = btn.dataset.src;
        if (btn.dataset.alt) main.alt = btn.dataset.alt;
      }
      document.querySelectorAll('.galerie-thumbs button').forEach(function (b) { b.classList.remove('actif'); });
      btn.classList.add('actif');
    });
  });
  // Quantité + / -
  document.querySelectorAll('.qty').forEach(function (box) {
    var input = box.querySelector('input');
    var minus = box.querySelector('[data-moins]');
    var plus = box.querySelector('[data-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
});

// Apparition au scroll + compteurs (v3.1)
document.addEventListener('DOMContentLoaded', function () {
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vu'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { obs.observe(el); });

    var obsNum = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, cible = parseFloat(el.dataset.cible || '0'),
            dec = parseInt(el.dataset.dec || '0', 10), suf = el.dataset.suffixe || '';
        var t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / 1400, 1); p = 1 - Math.pow(1 - p, 3);
          el.textContent = (cible * p).toFixed(dec).replace('.', ',') + suf;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step); obsNum.unobserve(el);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.stats .num').forEach(function (el) { obsNum.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('vu'); });
  }
});
